import { KnaufProjectSets } from './../knauf-project-set';
import { CompareProjectsService } from './../compare-projects.service';
import { ProjectService } from './../project.service';
import { Project } from './../project';
import { ActivatedRoute, Router } from '@angular/router';
import { KnaufPaletteSets } from './../knauf-palette-sets';
import { KnaufPaletteSetService } from './../knauf-palette-set.service';
import { Component, OnInit } from '@angular/core';
import { KnaufPalettes } from '../knauf-palettes.enum';
import { Palette } from '../palette';
import { KnaufProject } from '../knauf-project';
import { ModalService } from '../modal.service';
import { faPlus, faEdit } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-compose-color-set',
  templateUrl: './compose-color-set.component.html',
  styleUrls: ['./compose-color-set.component.sass']
})
export class ComposeColorSetComponent implements OnInit {
  title: string = "SKOMPONUJ SWOJE ZESTAWIENIE KOLORÓW";
  subtitle: string = 'Sprawdź różne połączenia barw i odcieni, eksperymentuj i baw się kolorami';
  next: string = '/finished-project'
  editor: string = '/editor'
  faPlus = faPlus;
  faEdit = faEdit;
  mobileActionActive: number = 0;
  mobileColorsActive: number = 0;
  styles = {
    selected: null,
    items: [
      {
        name: "Miejski szyk",
        class: "ms",
        palette: null,
        knaufPalette: KnaufPalettes.MiejskiSzyk,
        knaufProject: null,
        description: "Kolory podstawowe w tej palecie to szarości z nutką niebieskiego, fioletowego lub zielonego, które w gamie kolorów dodatkowych przechodzą w ciemniejsze odcienie grafitowo-stalowe. Akcentami uzupełniającymi są odcienie granatu i nasycony kolor żółty.",
        forWhom: "Dobry wybór dla ludzi aktywnych, kochających wartki rytm miejskiego życia, preferujących funkcjonalne i proste rozwiązania"
      },
      {
        name: "Klasyczna elegancja",
        class: "ke",
        palette: null,
        knaufPalette: KnaufPalettes.KlasycznaElegancja,
        knaufProject: null,
        description: "W tej palecie dominują kolory ziemi, od beży, poprzez brązy, aż do stonowanych rudości. Odnajdziemy tu kolor kamienia, mlecznej czekolady i wypalonej cegły. Gamę podstawowych barw ożywiają kolory dodatkowe w różnych odcieniach żółci, jasnych beży i brązów. Widzimy tu kolor piasku, cynamonu, cytryny i pomarańczy. Jako akcenty mamy do dyspozycji mocne kolory oscylujące wokół czerwieni.",
        forWhom: "Dobry wybór dla ludzi, którzy cenią klasyczne, sprawdzone połączenia i obawiają się eksperymentowania z kolorami."
      },
      {
        name: "Światowe inspiracje",
        class: "si",
        palette: null,
        knaufPalette: KnaufPalettes.SwiatoweInspiracje,
        knaufProject: null,
        description: "Paletę otwierają barwy rodem z architektury śródziemnomorskiej - nasycone odcienie żółtego, pomarańczowego, wypalonej cegły i różu, uzupełnione kolorami wody i nieba. Kolory dodatkowe to ciemniejsze odcienie kolorów podstawowych. Dopełnieniem są akcenty kolorystyczne od głębokiej, ciemnej zieleni, poprzez granatowy, ciemnorudy i miodowy, aż po kolor musztardowy.",
        forWhom: "Doskonały wybór dla osób kreatywnych, poszukujących niestandardowych rozwiązań architektonicznych i kolorystycznych."
      },
      {
        name: "W zgodzie z naturą",
        class: "zn",
        palette: null,
        knaufPalette: KnaufPalettes.WZgodzieZNatura,
        knaufProject: null,
        description: "Kolorami podstawowymi w palecie są zieleń i brąz z łagodną domieszką szarości i beżu. Kolory dodatkowe to przyjemne, pastelowe zielenie i świetliste beże, z którymi doskonale komponują się wyraziste akcenty kolorystyczne - barwy od butelkowej zieleni, poprzez zieleń groszkową, aż do nasyconej żółci.",
        forWhom: "Doskonały wybór dla wszystkich, którzy cenią życie blisko natury i dobrze czują się w otoczeniu uniwersalnych barw ziemi."
      },
      // {
      //   name: "Top Design",
      //   class: "zn",
      //   palette: null,
      //   knaufPalette: KnaufPalettes.TopDesign,
      //   knaufProject: null,
      //   description: "!Kolorami podstawowymi w palecie są zieleń i brąz z łagodną domieszką szarości i beżu. Kolory dodatkowe to przyjemne, pastelowe zielenie i świetliste beże, z którymi doskonale komponują się wyraziste akcenty kolorystyczne - barwy od butelkowej zieleni, poprzez zieleń groszkową, aż do nasyconej żółci.",
      //   forWhom: "!Doskonały wybór dla wszystkich, którzy cenią życie blisko natury i dobrze czują się w otoczeniu uniwersalnych barw ziemi."
      // },
      // {
      //   name: "Wszystkie kolory Knauf",
      //   class: "all",
      //   palette: null,
      //   knaufPalette: KnaufPalettes.invalid,
      //   knaufProject: null,
      //   description: "Pełna paleta kolorów tynków Knauf – prawie 800 odcieni, które możesz ze sobą dowolnie zestawiać i komponować.",
      //   forWhom: "Dla wszystkich, którzy samodzielnie chcąc dobrać kolory swojej elewacji"
      // }
    ]
  }
  palettes: KnaufPaletteSets;
  KnaufPalettes = KnaufPalettes;
  houseType: string;
  knaufPalette: number;
  project: Project;

  constructor(private palettesService: KnaufPaletteSetService,
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private compareProjectsService: CompareProjectsService,
    private modalService: ModalService,
    private router: Router) { }

  ngOnInit() {
    this.houseType = this.route.snapshot.paramMap.get('type');
    this.knaufPalette = Number(this.route.snapshot.paramMap.get('palette'));
    this.palettes = this.palettesService.getKnaufPaletteSets();
    this.styles.items[0].palette = this.palettes[KnaufPalettes.MiejskiSzyk];
    this.styles.items[0].knaufProject = KnaufProjectSets[KnaufPalettes.MiejskiSzyk][this.houseType];
    this.styles.items[1].palette = this.palettes[KnaufPalettes.KlasycznaElegancja];
    this.styles.items[1].knaufProject = KnaufProjectSets[KnaufPalettes.KlasycznaElegancja][this.houseType];
    this.styles.items[2].palette = this.palettes[KnaufPalettes.SwiatoweInspiracje];
    this.styles.items[2].knaufProject = KnaufProjectSets[KnaufPalettes.SwiatoweInspiracje][this.houseType];
    this.styles.items[3].palette = this.palettes[KnaufPalettes.WZgodzieZNatura];
    this.styles.items[3].knaufProject = KnaufProjectSets[KnaufPalettes.WZgodzieZNatura][this.houseType];
    // this.styles.items[4].palette = this.palettes[KnaufPalettes.TopDesign];
    // this.styles.items[4].knaufProject = KnaufProjectSets[KnaufPalettes.TopDesign][this.houseType];
    this.styles.selected = this.styles.items[this.knaufPalette];
    this.project = this.projectService.getProject();
    this.updateProject();
  }

  onStyleClick(item) {
    this.styles.selected = item;
    this.updateProject();
  }

  updateProject() {
    this.projectService.setSelectedColors(this.styles.selected.palette.proposed);
    this.projectService.setKnaufPalette(this.styles.selected.knaufPalette);
    this.projectService.setProjectImageFile(this.styles.selected.knaufProject.image);
    this.projectService.setOrgImageFile(this.styles.selected.knaufProject.image);
    this.projectService.setLayers(this.styles.selected.knaufProject.layers)
  }

  addProjectToCompare() {
    if (this.compareProjectsService.getProjects().length == 2) {
      this.openDialog('warning-dlg')
    } else {
      this.compareProjectsService.addProject(this.project);
      this.openDialog('confirmation-dlg');
    }
  }

  openDialog(dialog: string) {
    this.modalService.open(dialog);
  }

  closeModal(dialog: string) {
    // this.modalService.close(dialog);
  }
  onMobileActionActive(action: number) {
    this.mobileActionActive = action;
  }

  mobileSelectColorsActive(colors: number) {
    this.mobileColorsActive = colors;
  }
  onEditClick() {
    if (this.compareProjectsService.getProjects().length == 2) {
      this.modalService.open('editor-dlg');
    } else {
      this.router.navigate(['/editor']);
    }
  }
  goToMyProjects() {
    this.closeModal('editor-dlg');
    this.router.navigate(['/my-projects/fromedit']);
  }
  goToEditor() {
    this.closeModal('editor-dlg');
    this.router.navigate(['/editor']);
  }
}
